<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title">Edit Profile</h4>
    </div>
    <div class="card-body">
      <form>
        <div class="row">
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
              name="firstName"
              label="First Name"
              placeholder="First Name"
              v-on:blur="updateProfileData"
              v-model="model.firstName">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
              name="lastName"
              label="Last Name"
              placeholder="Last Name"
              v-on:blur="updateProfileData"
              v-model="model.lastName">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <fg-input type="text"
              name="phone"
              label="Mobile Number"
              v-on:blur="updateProfileData"
              placeholder="Phone Number"
              v-model="model.phone">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <fg-input type="text"
              name="address"
              label="Address"
              placeholder="Home Address"
              v-on:blur="updateProfileData"
              v-model="model.address">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <fg-input type="text"
              name="city"
              label="City"
              placeholder="City"
              v-on:blur="updateProfileData"
              v-model="model.city">
            </fg-input>
          </div>
          <div class="col-md-4">
            <label class="control-label">
              State
            </label>
            <el-select 
                name="states"
                size="large"
                placeholder="Choose One"
                v-model="selects.state_id"
                v-on:change="updateProfileData">
              <el-option v-for="option in selects.states" 
                class="select-primary"
                :selected="option.id == selects.state_id"
                :value="option.id"
                :label="option.name"
                :key="option.name">
              </el-option>
            </el-select>
          </div>
          <div class="col-md-4">
            <fg-input type="text"
              name="country"
              label="Country"
              placeholder="Country"
              v-model="model.country">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <fg-input type="number"
                name="postal_code"
                label="Postal Code"
                placeholder="100201"
                v-on:blur="updateProfileData"
                v-model="model.postal_code">
            </fg-input>
          </div>
        </div>

        <div class="clearfix"></div>
      </form>
    </div>
  </div>
</template>
<script>
  import {Input, Select, Option} from 'element-ui'

  export default {
    components: {
      [Option.name]: Option,
      [Select.name]: Select,
    },
    data () {
      return {
        model: {
          firstName: '',
          lastName: '',
          phone: '',
          address: '',
          city: '',
          country: '',
          postal_code: '',
          state_id: ''
        },

        selects: {
          state_id: '',
          states: []
        }
      }
    },
    methods: {

      updateProfileData () {
        this.model.state_id = this.selects.state_id
        this.$emit('on-submit', this.model, true)
      },

      getProfileData () {
        this.$http.get('/profiles')
        .then(response=>{
        
          this.model = response.data[0]
          this.selects.state_id =response.data[0]['state_id']
        })
        .catch(error=>{console(error)})
      },

      getStates () {
        this.$http.get('/states')
        .then(response=>{
        
          this.selects.states = response.data

        })
        .catch(error=>{console.error(error)})
      },
    },

    mounted () {
      this.getProfileData (),
      this.getStates ()
    
    }, 

  }

</script>
<style>

</style>
